import { encodeBase64Url } from "./base64"

// https://raw.githubusercontent.com/passkeydeveloper/passkey-authenticator-aaguids/main/aaguid.json
const aaguidNames = {
  "a11a5faa-9f32-4b8c-8c5d-2f7d13e8c942": `AliasVault`,
  "ea9b8d66-4d01-1d21-3ce4-b6b48cb575d4": `Google Password Manager`,
  "adce0002-35bc-c60a-648b-0b25f1f05503": `Chrome on Mac`,
  "08987058-cadc-4b81-b6e1-30de50dcbe96": `Windows Hello`,
  "9ddd1817-af5a-4672-a2b9-3e3dd95000a9": `Windows Hello`,
  "6028b017-b1d4-4c02-b4b3-afcdafc96bb2": `Windows Hello`,
  "dd4ec289-e01d-41c9-bb89-70fa845d4bf2": `iCloud Keychain (Managed)`,
  "531126d6-e717-415c-9320-3d9aa6981239": `Dashlane`,
  "bada5566-a7aa-401f-bd96-45619a55120d": `1Password`,
  "b84e4048-15dc-4dd0-8640-f4f60813c8af": `NordPass`,
  "0ea242b4-43c4-4a1b-8b17-dd6d0b6baec6": `Keeper`,
  "891494da-2c90-4d31-a9cd-4eab0aed1309": `Sésame`,
  "f3809540-7f14-49c1-a8b3-8f813b225541": `Enpass`,
  "b5397666-4885-aa6b-cebf-e52262a439a2": `Chromium Browser`,
  "771b48fd-d3d4-4f74-9232-fc157ab0507a": `Edge on Mac`,
  "39a5647e-1853-446c-a1f6-a79bae9f5bc7": `IDmelon`,
  "d548826e-79b4-db40-a3d8-11116f7e8349": `Bitwarden`,
  "fbfc3007-154e-4ecc-8c0b-6e020557d7bd": `Apple Passwords`,
  "53414d53-554e-4700-0000-000000000000": `Samsung Pass`,
  "50726f74-6f6e-5061-7373-50726f746f6e": `Proton Pass`,
  "fdb141b2-5d84-443e-8a35-4698c205a502": `KeePassXC`,
  "eaecdef2-1c31-5634-8639-f1cbd9c00a08": `KeePassDX`,
  "9addb28c-b46f-4402-808f-019651441ff3": `KeePassPasskey`,
  "cc45f64e-52a2-451b-831a-4edd8022a202": `ToothPic Passkey Provider`,
  "bfc748bb-3429-4faa-b9f9-7cfa9f3b76d0": `iPasswords`,
  "b35a26b2-8f6e-4697-ab1d-d44db4da28c6": `Zoho Vault`,
  "b78a0a55-6ef8-d246-a042-ba0f6d55050c": `LastPass`,
  "de503f9c-21a4-4f76-b4b7-558eb55c6f89": `Devolutions`,
  "22248c4c-7a12-46e2-9a41-44291b373a4d": `LogMeOnce`,
  "a10c6dd9-465e-4226-8198-c7c44b91c555": `Kaspersky Password Manager`,
  "d350af52-0351-4ba2-acd3-dfeeadc3f764": `pwSafe`,
  "d3452668-01fd-4c12-926c-83a4204853aa": `Microsoft Password Manager`,
  "6d212b28-a2c1-4638-b375-5932070f62e9": `initial`,
  "d49b2120-b865-4191-8cea-be84a52b0485": `Heimlane Vault`,
  "e8b7f4a2-c3d5-e6f7-890a-b1c2d3e4f567": `Sherlocked`,
  "d9be9d39-e6a6-4c28-a581-32b044d986e4": `Sticky Password Manager`,
  "70617373-7761-6c6c-6669-646f32303236": `Passwall`,
  "c9cadfc9-89a9-489e-a25a-c7e86a4d5f15": `Burp Suite Navigation Recorder`,
  "fa37f553-f9b6-4adb-ac53-8bbb57ebdf0d": `Norton Password Manager`,
  "a4a2d88e-9796-4356-9164-e2a5a8bd019c": `Avast Password Manager`,
  "e7db2bd3-f2fe-4d71-ad78-7e7aa166cfd1": `Avira Password Manager`,
  "6bb49926-160a-4306-a100-4eb39ba6ac45": `AVG Password Manager`,
  "66a0ccb3-bd6a-191f-ee06-e375c50b9846": `Thales Bio iOS SDK`,
  "8836336a-f590-0921-301d-46427531eee6": `Thales Bio Android SDK`,
  "cd69adb5-3c7a-deb9-3177-6800ea6cb72a": `Thales PIN Android SDK`,
  "17290f1e-c212-34d0-1423-365d729f09d9": `Thales PIN iOS SDK`,
}

export function credentialToJson(credential) {
  const response = credential.response

  const json = {
    id: credential.id,
    rawId: encodeBase64Url(credential.rawId),
    type: credential.type,
    response: {
      clientDataJSON: encodeBase64Url(response.clientDataJSON),
    },
  }

  if (response.attestationObject) {
    json.response.attestationObject = encodeBase64Url(
      response.attestationObject
    )
  }

  if (response.authenticatorData) {
    json.response.authenticatorData = encodeBase64Url(
      response.authenticatorData
    )
  }

  if (response.signature) {
    json.response.signature = encodeBase64Url(response.signature)
  }

  if (response.userHandle) {
    json.response.userHandle = encodeBase64Url(response.userHandle)
  }

  return json
}

function parseAttestationObject(buffer) {
  const bytes = new Uint8Array(buffer)
  let offset = 0

  function readCBOR() {
    const first = bytes[offset++]
    const type = first >> 5
    const info = first & 0x1f

    let length
    if (info < 24) {
      length = info
    } else if (info === 24) {
      length = bytes[offset++]
    } else if (info === 25) {
      length = (bytes[offset++] << 8) | bytes[offset++]
    } else if (info === 26) {
      length =
        bytes[offset++] * 0x1000000 +
        (bytes[offset++] << 16) +
        (bytes[offset++] << 8) +
        bytes[offset++]
    }

    switch (type) {
      case 0:
        return length
      case 2: {
        const result = bytes.slice(offset, offset + length)
        offset += length
        return result
      }
      case 3: {
        const result = new TextDecoder().decode(
          bytes.slice(offset, offset + length)
        )
        offset += length
        return result
      }
      case 5: {
        const result = {}
        for (let i = 0; i < length; i++) {
          const key = readCBOR()
          result[key] = readCBOR()
        }
        return result
      }
      default:
        return null
    }
  }

  return readCBOR()
}

export function getAuthenticatorNameFromCredential(credential) {
  const attestationObject = credential.response.attestationObject
  if (!attestationObject) return null

  try {
    const parsed = parseAttestationObject(attestationObject)
    const authData = parsed && parsed.authData
    if (!authData || authData.length < 53) return null

    // AAGUID occupies bytes 37–52 of authData:
    // 32 bytes rpIdHash + 1 byte flags + 4 bytes signCount = offset 37
    const aaguid = authData.slice(37, 53)
    const hex = Array.from(aaguid)
      .map((b) => b.toString(16).padStart(2, `0`))
      .join(``)
    const uuid = [
      hex.slice(0, 8),
      hex.slice(8, 12),
      hex.slice(12, 16),
      hex.slice(16, 20),
      hex.slice(20, 32),
    ].join(`-`)

    return aaguidNames[uuid] || null
  } catch {
    return null
  }
}
